import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewThesesComponent } from './new-theses/new-theses.component';
import { SharedCompilationModule } from '../shared/shared-compilation.module';
import { ThesesRoutingModule } from './theses.routing';
import { ThesesAuthorsComponent } from './theses-authors/theses-authors.component';
import { ThesesDataComponent } from './theses-data/theses-data.component';
import { ThesesDoneComponent } from './theses-done/theses-done.component';
import { ThesesService } from '../services/data/theses.service';
import { AccordionModule } from 'primeng/accordion';
import { ThesesEndRegMsgComponent } from './theses-end-reg-msg/theses-end-reg-msg.component';

@NgModule({
  declarations: [
    NewThesesComponent,
    ThesesAuthorsComponent,
    ThesesDataComponent,
    ThesesDoneComponent,
    ThesesEndRegMsgComponent,
  ],
  imports: [
    CommonModule,
    SharedCompilationModule,
    ThesesRoutingModule,
    AccordionModule,
  ],
  providers: [ ThesesService ]
})
export class ThesesModule { }
